export default __webpack_public_path__ + "static/gb-nir-d60ecd946d5a8e91e615012bfca091e3.svg";